import uniqid from 'uniqid'
import config from './config'
// import config from '@/utils/config'

const topMenuItems = [
  {
    path: '/',
    text: 'menus.topmenu.new.title',
    active: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/alta/nueva-factura',
        text: 'menus.topmenu.new.create',
        active: true,
        key: uniqid()
      },
      {
        path: '/alta/importar',
        text: 'menus.topmenu.new.import',
        active: true,
        key: uniqid()
      }
    ]
  },
  /* {
    path: '/emitidas/financiacion',
    text: 'menus.topmenu.financing',
    active: config.features.requestFactoringMenuItem,
    key: uniqid()
  }, */
  {
    path: '/agenda',
    text: 'menus.topmenu.agenda',
    active: true,
    key: uniqid()
  },
  {
    path: '/',
    text: 'menus.topmenu.configuration.title',
    active: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/configuracion/datos-generales',
        text: 'menus.topmenu.configuration.companyData',
        active: true,
        key: uniqid()
      },
      {
        path: '/configuracion/users',
        text: 'menus.topmenu.configuration.users',
        active: true,
        key: uniqid()
      },
      // {
      //   path: '/configuracion/not-factura',
      //   text: 'menus.topmenu.configuration.notification',
      //   active: true,
      //   key: uniqid()
      // },
      {
        path: '/configuracion/gestion-de-claves',
        text: 'menus.topmenu.configuration.keys',
        active: config.features.hasKeyConfiguration,
        key: uniqid()
      },
      {
        path: '/configuracion/catalogo',
        text: 'menus.topmenu.configuration.catalog',
        active: config.features.hasCatalog,
        key: uniqid()
      },
      {
        path: '/configuracion/formato-factura',
        text: 'menus.topmenu.configuration.invoiceFormat',
        active: true,
        key: uniqid()
      }
    ]
  },
  {
    path: '/',
    text: 'menus.topmenu.help.title',
    active: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/ayuda/manual-usuario',
        text: 'menus.topmenu.help.manual',
        active: true,
        key: uniqid()
      },
      {
        path: '/ayuda/acercade',
        text: 'menus.topmenu.help.about',
        active: true,
        key: uniqid()
      }
    ]
  }
]

export default topMenuItems
